import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import ModalPortal from '../../../../../components/modal-portal';
import { useModal } from '../../../../../hooks/use-modal';
import { refreshDeliveryEmailTemplates, refreshShipmentEmailTemplates } from '../../../../../store/seller/seller.actions';
import { deleteEmailTemplate } from '../../api';
import { SHIPMENT_EMAILS_TAB } from '../../constants';
import messages from '../../messages';
import { apiError } from '../../on-api-error';
import ConfirmDeletionModal from '../confirm-delete-modal';

/**
 * @param {object} props
 * @param {(props: { onDeleteClicked: (template: object) => void }) => React.ReactNode} props.children
 * @param {() => void} props.onDeleted
 * @param {typeof import('../../constants').SHIPMENT_EMAILS_TAB | typeof import('../../constants').DELIVERY_EMAILS_TAB} props.selectedTab
 * @returns {React.JSX.Element}
 */
export const DeleteTemplate = ({ children, onDeleted, selectedTab }) => {
  const [emailTemplate, setEmailTemplate] = useState();
  const { open, close, isOpen } = useModal();

  const dispatch = useDispatch();
  const onDeleteConfirmed = (templateId) => {
    deleteEmailTemplate(templateId)
      .then(() => {
        close();
        onDeleted();
        if (selectedTab === SHIPMENT_EMAILS_TAB) {
          dispatch(refreshShipmentEmailTemplates());
          return;
        }
        dispatch(refreshDeliveryEmailTemplates());
      })
      .catch(() => apiError(messages.apiDeleteError));
  };

  const onDeleteClicked = (template) => {
    setEmailTemplate(template);
    open();
  };
  const onModalClose = () => {
    close();
    setEmailTemplate(undefined);
  };
  return (
    <>
      {children({ onDeleteClicked })}
      {isOpen ? (
        <ModalPortal onClose={onModalClose}>
          <ConfirmDeletionModal emailTemplate={emailTemplate} onConfirm={onDeleteConfirmed} />
        </ModalPortal>
      ) : null}
    </>
  );
};
